module.exports = __webpack_public_path__ + "img/qx60-25.eb47ca9b.png";